<template>
	<div :class="res == 1 ? 'panel ineligible' : 'panel'">
		<h2 id="resfail" class="resfail" v-if="res !== 0">{{text.fail[res - 1][0]}}</h2>
		<!-- Applied for Balance Transfer, and approved (commented the below line as part of summary page removal change) -->
		<!-- <h2 v-if="balanceTransferRequestedDecision == 'Y' && res == 0" role="status">{{text.btsucc1 + text.creditAmount + text.btsucc2}}</h2> -->
		
		<!-- Approved for a product but without Balance Transfer (commented the below line as part of summary page removal change) -->
		<!-- <h2 v-else-if="res == 0" role="status">{{text.succ1 + text.name + text.succ2}}</h2> -->

		<p v-if="res !== 0" id="failhead" role="status" :class="(res == 1) ? 'unablehead failhead' : 'failhead'">
			{{text.fail[res - 1][1]}}
		</p>
		<p class="tryagain" v-if="res == 2">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
				<g clip-path="url(#clip0_99_6681)">
				<path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM15.55 15.8L11.47 13.29C11.17 13.11 10.99 12.79 10.99 12.44V7.75C11 7.34 11.34 7 11.75 7C12.16 7 12.5 7.34 12.5 7.75V12.2L16.34 14.51C16.7 14.73 16.82 15.2 16.6 15.56C16.38 15.91 15.91 16.02 15.55 15.8Z" fill="black"/>
				</g>
				<defs>
				<clipPath id="clip0_99_6681">
				<rect width="24" height="24" fill="white"/>
				</clipPath>
				</defs>
			</svg>
			<span>Please try again later</span>
		</p>
		<a v-if="res == 2" class="link" href="#" @click.prevent="reload"><span>Post Office Credit Card QuickCheck</span></a>

		<!-- Applied for Balance Transfer, but not approved -->
		<!-- commented the below lines as part of summary page removal change -->
		<!-- <p v-if="balanceTransferRequestedDecision == 'N' && res == 0" class="btNotApprovedSubheading">{{text.btfail1 + text.creditAmount + text.btfail2}}</p> -->
		<!-- <p v-if="res == 0">{{text.succdesc}}</p> -->

		<p v-if="res == 1" id="scorefactor">{{text.fail[res - 1][2]}}</p>
		<p v-if="res == 1" class="dataMessage">We may use data from <a class="inline-link" href="https://www.equifax.co.uk/" target="_blank">Equifax</a>, <a class="inline-link" href="https://www.transunion.co.uk/crain" target="_blank">Transunion</a> and <a class="inline-link" href="https://www.experian.co.uk/" target="_blank">Experian</a> to decide if we can lend to you, so it's important this information is correct. You can sign up with them to check your details (some may charge a fee).</p>
	</div>
</template>

<script>

export default {
	name: 'resHeader',
	props: {
		res: Number,
		text: Object,
		balanceTransferRequestedDecision: String
	},
	methods: {
		reload() {
			window.location.reload();
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel {
	display: flex;
	flex-direction: column;
	align-items: center;
	background: white;
	padding: 3.5rem;
	border-radius: 1rem;
	margin-top: 2rem;
	text-align: center;
	grid-row: 2;
	grid-column: 2 / span 10;
	border: 0.0625rem solid #e6e6e6;
}

.panel.ineligible {
	display: grid;
	column-gap: 1.5rem;
	grid-template-columns: repeat(10, 1fr);
	text-align: left;
	align-items: flex-start;
	padding-left: 0;
	padding-right: 0;
}

.panel.ineligible > * {
	grid-column: 3 / span 6;
}

.panel.ineligible p {
	margin: 0;
}

.panel.ineligible p:first-of-type {
	margin-top: 1.5rem;
}

.panel.ineligible p + p {
	margin-top: 1.5rem;
}

.inline-link {
	font-family: "Nunito Sans", "Helvetica", "Arial", sans-serif;
    color: #2b60de;
    background-color: rgba(0, 0, 0, 0);
    position: relative;
	word-wrap: break-word;
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: bold;
    padding: .125rem 0 .03125rem 0;
    text-underline-offset: .35625rem;
    text-decoration-thickness: .0625rem;
    transition: .1s;
}

.inline-link:hover {
	background: #eaeffc;
	text-decoration: none;
}

.inline-link:active {
	background: #2b60de;
	color: white;
	text-decoration: none;
}

.inline-link:focus-visible {
	background-color: #ffd801;
    color: #252a36;
    text-decoration: none;
    text-underline-offset: .3125em;
    text-decoration-thickness: .0625rem
}

.link {
	font-family: "Nunito Sans", "Helvetica", "Arial", sans-serif;
    color: #2b60de;
    background-color: rgba(0, 0, 0, 0);
    position: relative;
    cursor: pointer;
	word-wrap: break-word;
    font-size: 1.125rem;
    line-height: 2rem;
    font-weight: 700;
	text-decoration: none;
	margin-top: 2rem;
}
.link:hover {
	text-decoration: none;
	background-color: #f2e6f2;
}
.link span {
	text-decoration: underline;
    padding: .25rem 0 .21875rem 0;
    text-underline-offset: .5em;
    text-decoration-thickness: .0625rem;
    transition: .1s;
}
.link:active span {
	background: #2b60de;
	color: white;
}
.link:focus-visible span {
	background: #ffd801;
	color: #252a36;
}
.resfail {
	font-size: 1.875rem;
	line-height: 2.5rem;
	font-weight: bold;
	margin: 0;
	color: #2E1A47;
}
.failhead {
	font-size: 1.125rem;
	font-weight: normal;
	margin: 0;
	margin-top: 1.5rem;
}
.tryagain {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 0.5rem;
	font-size: 1.3125rem;
	line-height: 1.96875rem;
	font-weight: bold;
	margin: 0;
	margin-top: 1.5rem;
}
.tryagain svg {
	width: 1.5rem;
	height: 1.5rem;
}

@media screen and (max-width: 63.9375rem) {
	.panel {
		padding: 2.5rem;
	}
	.panel.ineligible {
		display: grid;
		column-gap: 1.5rem;
		grid-template-columns: repeat(10, 1fr);
		padding-left: 0;
		padding-right: 0;
	}
	.panel.ineligible > * {
		grid-column: 2 / span 8;
	}
	.resfail {
		font-size: 1.5rem;
		line-height: 2.125rem;
	}
 }

@media screen and (max-width: 47.938rem) { 
	.panel {
		padding: 2rem 1.5rem;
		grid-column: 1 / span 4;
	}
	.panel.ineligible {
		grid-template-columns: repeat(4, 1fr);
		padding: 2rem 0;
		column-gap: 1rem;
	}
	.panel.ineligible > * {
		grid-column: 1 / span 4;
		padding: 0 1.5rem;
	}
}


</style>